<template>
  <div>
    <el-row>
      <el-col :span="1">
        <i @click="backToHome" class="el-icon-arrow-left back"></i>
      </el-col>
      <el-col :span="22" class="title">
        {{book.name}}-{{unit.name}}-{{type=='read'?'认读':type=='listen'?'辨音':'拼写'}}
      </el-col>
      <el-col :span="1">
        <i @click="changeChapterShow" class="el-icon-notebook-2 back"></i>
      </el-col>
    </el-row>
    
  </div>
</template>

<script>
export default {
  props: ['book','unit','type'],
  methods: {
    changeChapterShow() {
      this.$emit('click')
    },
    backToHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.back{
  font-size: 2.8em;
  margin: 15px 0 0 0;
}
.title{
  margin: 5px 0 0 0;
  font-size: 1.5em
}
</style>
